module.exports = __webpack_public_path__ + "static/video1-a8f37fbf5d62474cd31567b736bb0587.jpg";